import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#clip0_18006_92790)\"><g clip-path=\"url(#clip1_18006_92790)\"><path d=\"M15.1248 1.25839C7.4609 1.25839 1.26886 7.39933 1.26886 15C1.26886 22.6007 7.4609 28.7416 15.1248 28.7416C22.7888 28.7416 28.9808 22.6007 28.9808 15C28.9808 7.39933 22.7888 1.25839 15.1248 1.25839ZM15.1248 30C6.8011 30 0 23.255 0 15C0 6.74497 6.8011 0 15.1248 0C23.4486 0 30.2497 6.74497 30.2497 15C30.2497 23.255 23.4486 30 15.1248 30Z\" fill=\"#231F20\"></path><path d=\"M19.5922 15.7037C19.237 17.8681 17.359 19.4789 15.1259 19.4789C12.6389 19.4789 10.6087 17.4654 10.6087 14.999C10.6087 12.5326 12.6389 10.5191 15.1259 10.5191C17.359 10.5191 19.237 12.1802 19.5922 14.2943L20.7596 13.6399C20.1505 11.1232 17.8666 9.26074 15.1259 9.26074C11.9283 9.26074 9.33984 11.8279 9.33984 14.999C9.33984 18.1701 11.9283 20.7373 15.1259 20.7373C17.8666 20.7373 20.1505 18.8748 20.7596 16.3581L19.5922 15.7037Z\" fill=\"#231F20\"></path><path d=\"M16.4946 6.29102L15.8348 7.44873C19.7429 7.80108 22.7881 11.0729 22.7881 14.9991C22.7881 19.1769 19.3368 22.5997 15.1242 22.5997C10.9116 22.5997 7.46029 19.1769 7.46029 14.9991C7.46029 11.0729 10.5056 7.80108 14.4137 7.44873L13.7538 6.29102C9.49047 6.94538 6.24219 10.6199 6.24219 14.9991C6.24219 19.8816 10.2518 23.8581 15.175 23.8581C20.0982 23.8581 24.1078 19.8816 24.1078 14.9991C24.057 10.6199 20.758 6.94538 16.4946 6.29102Z\" fill=\"#231F20\"></path><path d=\"M15.1265 3.07324C8.98523 3.07324 3.90978 7.65378 3.19922 13.5934L4.41733 14.2981C4.82336 8.76116 9.44202 4.38197 15.1265 4.38197C21.0648 4.33163 25.8865 9.11351 25.8865 15.0028C25.8865 20.892 21.0648 25.6739 15.1265 25.6739C9.44202 25.6739 4.82336 21.2947 4.41733 15.7578L3.19922 16.4625C3.90978 22.3518 8.98523 26.9323 15.1265 26.9323C21.7754 26.9323 27.1553 21.5967 27.1553 15.0028C27.1553 8.40881 21.7754 3.07324 15.1265 3.07324Z\" fill=\"#231F20\"></path></g></g><defs><clipPath id=\"clip0_18006_92790\"><rect width=\"30.625\" height=\"30\" fill=\"white\"></rect></clipPath><clipPath id=\"clip1_18006_92790\"><rect width=\"134.043\" height=\"30\" fill=\"white\"></rect></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'cybersystemLogo',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#211F58",
  },
  width: {
    type: Number as PropType<number>,
    default: 31,
  },
  height: {
    type: Number as PropType<number>,
    default: 30,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.width,
    height: __props.height,
    viewBox: `0 0 ${__props.width} ${__props.height}`,
    fill: "none"
  }, _hoisted_4, 8, _hoisted_1))
}
}

})